import React from 'react';
import styles from './styles.module.scss';

/**
 * Responsavel por gerar o label para um formulario
 * @param {string} fieldName
 * @param {any} className
 * @param {boolean} isSpan
 */
export default function FormLabel(fieldName, className, isSpan = false) {
    return isSpan ? (
        <span className={[styles.tituloNegritoLabels, className ? className : ''].join(' ')}>{fieldName}</span>
    ) : (
        <label className={[styles.tituloNegritoLabels, className ? className : ''].join(' ')}>{fieldName}</label>
    );
}
